module.exports = __webpack_public_path__ + "static/media/live-dashboard-icon.31e02777.svg";